import React from 'react'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import { SelectableBoxView, SelectableBoxViewProps } from 'components/_new/controls'

import s from './SelectableOptionView.scss'


export type SelectableOptionViewProps = Omit<SelectableBoxViewProps, 'icon' | 'iconPosition' | 'iconClassName' | 'iconColor'> & {
  type: 'checkbox' | 'radio'
  checked: boolean
}

const SelectableOptionView: React.FunctionComponent<SelectableOptionViewProps> = (props) => {
  const { children, type, checked, className, ...rest } = props

  const activeIcon = type === 'radio' ? 'radio' : 'checkmark'

  return (
    <SelectableBoxView
      className={cx(s.container, className)}
      icon={checked ? activeIcon : 'empty'}
      iconColor="brand"
      iconPosition={null}
      iconClassName={s.icon}
      fullWidth
      withBg
      {...rest}
    >
      <Box pt={20} pr={16} pb={20} pl={56}>
        {children}
      </Box>
    </SelectableBoxView>
  )
}


export default SelectableOptionView
